module.exports = __webpack_public_path__ + "img/icon-plus.5da3fca6.svg";